import Vue from 'vue';

const success = (response, context) => {
  context.allProperties = response.all_properties;
  context.allProperties.map((property,index) => {
    property.checked = false;
    property.roomTypes.map((room) => {
      room.checked = false;
    });
  });
  context.loading = false;
  context.openModal('#get-properties-modal');
};

const failed = (error, context) => {

};

export default (context) => {
    return Vue.$http.get('/rentals/get-properties')
        .then((response) => {
            if (response && response.status === 200) {
                success(response.data, context);
            } else {
              failed(response, context);
            }
    }).catch((error) => {
        failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/getProperties.js